<template>
<div>
  <div class='glitchHolder'>
      <div v-if="glitches" id="glitchOverlay" :style="{top:glitchTop+'px'}">
        <div v-for="g in glitches" class='glitchOver' :style="{marginBottom:g.pad+'px',width:g.width+'%'}">
        <div v-for="gc in g.child" class='glitchChild' :style="{backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'}"></div>
        </div>
      </div>
    </div>
  <v-container ma-0 pt-0>

    <v-layout >
      <v-flex xs12 class="text-xs-center">
      <v-progress-circular indeterminate :size="50" 
      color="grey" 
      :width="7" 
      v-if="loading"></v-progress-circular>
      </v-flex>
    </v-layout>
    
     <v-layout>
      <v-flex xs12 sm6 pa-0 pr-4 v-if="false">
        <div v-if="nowPlaying">
          <div v-if="nowPlaying.type=='title'" class="titlePreview" style:>
            <div class=pTitle>{{nowPlaying.title}}</div>
            <div class=pSubtitle>{{nowPlaying.subtitle}}</div>
            <div class=pBody>{{nowPlaying.body}}</div>
            <div class=pFooter>{{nowPlaying.footer}}</div>
          </div>
          <v-img v-if="false" :src="nowPlaying.imageUrl"></v-img>
          <h3>{{nowPlaying.title}} - {{nowPlaying.artist}}</h3>
          <h4>{{nowPlaying.description}}</h4>
        </div>
      </v-flex>

    <v-flex xs12 sm8 offset-sm2  pa-0>
        <div style="cursor:pointer" v-if="!loading">
        <div v-if="status">
          <v-layout justify-space-between row >
          <v-flex xs10>
         <h2>Todays Schedule</h2>
         <!--<p>Launch Program - Check back tomorrow for full schedule</p>-->
          </v-flex>
          <v-flex >
     
      </v-flex>
          </v-layout>
          <ScheduleView v-if="status" :schedule="currentSchedule"></ScheduleView>
         </div>
        </div>
         </v-flex>
    </v-layout>
  </v-container>
  </div>
</template>

<script>
import ScheduleView from './Content/ScheduleView.vue';

 export default {
   components: { ScheduleView },
   data () {
     return {
       trackInfo:[],
       prelaunch:false,
       lastPlaylistId:null,
       hasPlaying:false,
       plistIds:[],
       scheduleDisplay:null,
       nowPlaying:null,
       currentSchedule:null,
       lastTrack:null,
       currentTrack:null,
       date:null,
       dateModal:false,

      glitches:null,
      glitchCount:20,
      glitchTop:0
     }
   },
   mounted(){
     //this.$store.dispatch('loadStatus');
     this.glitches=[]
     let childA=[]  
      for(var i=0;i<8;i++){
        childA=[]
        for(var p=0;p<2;p++){
          childA.push(Math.floor(Math.random()*100));   
        }
        this.glitches.push({colour:'#00000044',height:30,pad:3,width:Math.random()*50+50,child:childA})
      }
      setTimeout(this.glitch,100);
      console.log("MOUNTED",this.status)
      this.date=new Date().toISOString().substr(0, 10);
      console.log("PROGRAM MOUNTED")
   },
   computed: {
      hasStatus(){
        return this.$store.getters.getStatus !=null;
      },
      status () {
       
       return this.$store.getters.getStatus
     },
     tracks () {
       
       return this.$store.getters.getTracks
     },
     trackIndex(){
       if(status){
        return status.active
       }else{
         return null
       }
     },
     schedules () {
      
       return this.$store.getters.loadedSchedules
     },
     loading () {
       return this.$store.getters.loading
     },
     userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
     
    
    },
  watch:{ status(status){
      console.log("Watch status",status);
      this.currentTrack=(status.active);
      if(this.currentTrack!=this.lastTrack ){
        this.currentSchedule=this.$store.getters.loadedSchedule(status.schedule)
        this.lastTrack=this.currentTrack;
        var key=this.tracks.tracks[this.currentTrack-1].split('.')[0];
        if(key.substr(0,1)=="-"){
          this.nowPlaying = this.$store.getters.loadedContent(key) 
        }else{
          this.nowPlaying = this.getContent(this.currentSchedule.items[this.currentTrack-1].id);       
        }
        
      }
    }

  },
   methods: {
     allowedDates(val){
            parseInt(val.split('-')[2], 10) % 2 === 0
        },
     playlistInfo(playlist){
       this.plistIds.push(playlist.id)
       if( this.plistIds.length>1 && this.plistIds[ this.plistIds.length-1]==this.plistIds[ this.plistIds.length-2]){
         //this.lastPlaylistId=playlist.id;
         return null;
       }else{
         return "[ "+playlist.name+" ]"
       }
     },
     

     showSchedule (id){
       console.log("SHOW",id);
     },
     
     
     getContent(id){
       //console.log("GET CONTENT",id)
       // console.log(this.$store.getters.loadedContent(id));
              return this.$store.getters.loadedContent(id)
    },
    getPlaylist(id){
      
      return this.$store.getters.loadedPlaylist(id)
    },
    secondsToDuration(sec){
        var hrs=Math.floor(sec/(60*60));
        var mins=Math.floor((sec-hrs*60*60)/60);
        var secs=Math.floor(sec%60);
        if(hrs<10){hrs="0"+hrs}
        if(mins<10){mins="0"+mins}
        if(secs<10){secs="0"+secs}
        return hrs+":"+mins+":"+secs
      },
      glitch(){
        this.glitchCount++
        if(this.glitchCount>50){
            this.glitchCount=Math.random()*20-10
            this.glitchTop=Math.random()*400+100;
        }
       if(this.glitchCount>10){
         this.glitchCount+=Math.random()*40
          setTimeout(this.glitch,Math.random()*100+100);
          return
       }
        for(var g in this.glitches){
          if(Math.random()*10>7){
            this.glitches[g].height=Math.random()*20+5;
            for(var gc in this.glitches[g].child){
                this.glitches[g].child[gc]=Math.floor(Math.random()*160+20);
            }
             if(Math.random()*10>5){
               this.glitches[g].height=0;
             }
          }
          this.glitches[g].pad=Math.floor(Math.random()*5+5)
          this.glitches[g].width=Math.floor(Math.random()*160+20) 
        }
        if(Math.random()*10>5){
         // this.glitchTop=Math.random()*400+100;
        }
        setTimeout(this.glitch,100);
     }
   }
 }
</script>

<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top:0px;
    
}
  .title{
    position:absolute;
    bottom:50px;
    background-color:rgba(0,0,0,0.5);
    color:#fff;
    padding:5px;
    font-size:2em;
  }
  .screen {
    margin:auto;
    top:30%;
    background-color: #f7f7f7;
    width: 64%;
    padding-top: 40%; /* 1:1 Aspect Ratio */
    position: relative; /* If you want text inside of it */
    box-shadow: black 0px 0px 50px 0px;
}

/* If you want text inside of the container */
.screentext {
    
    position: absolute;
    top: 35%;
    left: 0;
    bottom: 0;
    right: 0;
    font-size: 20px;
    font-weight: 700;
    color: #7f7f7f;
    text-shadow: #00000033 0px 0px 20px;
}
.titlePreview{
  position:relative;
  width:64%;
  padding-top:40%;
  height:100%;
  background-color:#000;
  color:#fff;
  margin: auto;
  text-align: center;
  position:relative;
}
.titlePreview .pTitle{
  position: absolute;
  width:100%;
  top:5%;
  font-size:70%;
}
.titlePreview .pSubtitle{
  position: absolute;
  width:100%;
  top:10%;
  font-size:40%;
}
.titlePreview .pBody{
  position: absolute;
  top:20%;
  width:100%;
  font-size:40%;
}
.titlePreview .pFooter{
  text-align: center;
  width:100%;
  position: absolute;
  bottom:5%;
  font-size:40%;
}
.glitchHolder{
    position: absolute;
    top: 0px;
    height: 100%;
    width: 100%;
    min-height: 100px;
    overflow: hidden;
    pointer-events: none;
    opacity:0.5;
  }
  #glitchOverlay{
  position:absolute;
  left:-100px;
  top:0px;
}
.glitchOver{
  
  z-index:3;
  position:relative;
  min-height:30px;
  pointer-events:none;
  opacity:0.3;
  width:400px;
  
}
.glitchChild{
  width:40px;
  display:inline-block;
  background-color:#00f;
}
</style>



// WEBPACK FOOTER //
// src/components/Program.vue